import { createStore, applyMiddleware, combineReducers, compose } from 'redux';
import thunk from 'redux-thunk';
import { routerMiddleware } from 'react-router-redux';
import createHistory from 'history/createBrowserHistory';

import loginReducer from './pages/Login/loginReducer';
import alertReducer from './pages/alertReducer';
import authReducer from './pages/authReducer';
import registerReducer from './pages/Register/registerReducer';
import currentUserReducer from './pages/Usersettings/currentUserReducer';
import userReducer from './pages/User/userReducer';
import petReducer from './pages/Pet/petReducer';
import petsReducer from './pages/Pets/petsReducer';
import searchReducer from './pages/Search/searchReducer';
import requestReducer from './pages/Request/requestReducer';
import messagesReducer from './pages/Messages/messagesReducer';

const history = createHistory();
const reduxRouterMiddleware = routerMiddleware(history);
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
  combineReducers({
    userReducer,
    loginReducer,
    registerReducer,
    alertReducer,
    currentUserReducer,
    petReducer,
    petsReducer,
    searchReducer,
    requestReducer,
    authReducer,
    messagesReducer
  }),
  undefined,
  composeEnhancers(applyMiddleware(thunk, reduxRouterMiddleware)),
);

export default store;



// WEBPACK FOOTER //
// ./src/store.js